import React from "react";
import logo from '../assets/logo.png';

const Header = () => {
  return (
    <header
      className="bg-header shadow-sm position-relative"
      style={{
        borderBottom: "4px solid #0277bd",
        height: "70px",
      }}
    >
      <div className="container-fluid d-flex align-items-center justify-content-between h-100 px-3">
        {/* Logo */}
        <div className="d-flex align-items-center">
          <img
            src={logo}
            alt="Logo"
            height="40"
            style={{ cursor: "pointer", maxWidth: "100%" }}
          />
        </div>

        {/* Title - Responsive */}
        <div
          className="position-absolute start-50 top-50 translate-middle text-center"
          style={{
            whiteSpace: "nowrap",
            pointerEvents: "none",
            maxWidth: "90vw",
          }}
        >
          <h5 className="mb-0 text-dark fw-bold d-none d-sm-block">
            उपस्थिति प्रबंधन प्रणाली
          </h5>
          <h6 className="mb-0 text-dark fw-bold d-block d-sm-none" style={{ fontSize: "14px" }}>
            उपस्थिति प्रणाली
          </h6>
        </div>
      </div>
    </header>
  );
};

export default Header;
